import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		SlevamatSk: [],
	},
	filter: {
		VyrobekndOzn: null as string | null,
		RabatSk: null as string | null,
		SlevamatSk: null as number | null,
		RabatSkText: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutations.SLEVAMAT_RABAT_SK_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.RabatSk = data.value;
			state.filter.RabatSkText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
